import React from "react";
import "./About.css"; // Create a CSS file for styling

const About = () => {
    return (
        <div className="about-container">
            <h1>About Muslims.wtf</h1>
            <p>
                <b>Muslims.wtf</b> is a data-driven platform dedicated to providing factual insights
                into terrorist attacks. Our goal is to <b>analyze trends, expose narratives, and ensure
                transparency</b> through publicly available data.
            </p>

            <h2>Why This Project Exists</h2>
            <p>
                In a world where news cycles move fast and narratives shift even faster, understanding
                the real impact of events is crucial. <b>Muslims.wtf</b> aggregates attack data, allowing
                users to explore trends beyond media headlines.
            </p>

            <h2>Sources</h2>
            <p>
              I keep a close eye on the news and regularly check the following sources to make sure I haven’t missed anything:
            </p>
            <ul>
              <li>
                <a href="https://www.start.umd.edu/data-tools/GTD" target="_blank" rel="noopener noreferrer">
                  Global Terrorism Database (GTD) – START, University of Maryland
                </a>
              </li>
              <li>
                <a href="https://data.gttac.com/comparative-research-tool" target="_blank" rel="noopener noreferrer">
                  GTTAC Comparative Research Tool
                </a>
              </li>
              <li>
                <a href="https://en.wikipedia.org/wiki/List_of_terrorist_incidents_in_2025" target="_blank" rel="noopener noreferrer">
                  Wikipedia – List of terrorist incidents in 2025
                </a>
              </li>
              <li>
                <a href="https://infoguides.gmu.edu/conflict/data" target="_blank" rel="noopener noreferrer">
                  George Mason University – Conflict &amp; Terrorism Data Resources
                </a>
              </li>
            </ul>

            <h2>How You Can Help</h2>
            <p>
                If you notice missing data, inaccuracies, or have additional sources to contribute,
                we’d love to hear from you.
            </p>
            <p className="contact-info">
                📧 <b>Contact us at</b>: <a href="mailto:info@muslims.wtf">info@muslims.wtf</a>
            </p>
        </div>
    );
};

export default About;
